export default __webpack_public_path__ + "static/media/dblawtx.72c23eda.png";